<template>
  <div class="profile-layout sample-profile type-report">
    <sample-navbar></sample-navbar>
    <div class="wrapper report" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path:
                'vestimate-report-about-data',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Business Value',
              icon: 'developer_board',
              path: 'business-value',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'swot-analysis' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Scores',
                icon: 'star_half',
                path: 'scores',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'company-context' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Company-Context',
                icon: 'broken_image',
                path: 'company-context',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'market-insights' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Market Environment',
                icon: 'receipt_long',
                path: 'market-environment',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Financial Analysis',
              icon: 'pie_chart',
              path: 'finanical-analysis',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'KPI Details',
              icon: 'scatter_plot',
              path: 'kpi-details',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Valuation Approach',
              icon: 'info',
              path: 'vestimate-approach',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Customize Report',
              icon: 'tune',
              path:
                'vestimate-customize-report',
            }"
          ></sidebar-item>
          <!-- No "Manage Inputs" tab on the sample: the sample profile is shared by
               every visitor, so its inputs are never submittable (VRManageInputs hides
               Submit via isSample) and showing editable fields only looked broken. -->
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- your content here -->
              <router-view :headerData="headerData" v-if="!loading || isAboutRoute" />
             <!-- <PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader> -->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import SampleNavbar from './SampleNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from '@/components';
import Vuex, { mapActions } from 'vuex';
import axios from 'axios';

export default {
  components: {
    SampleNavbar,
    ContentFooter,
    PulseLoader,
    MobileMenu,
  },
  data() {
    return {
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      expandNews: false,
      expandSingle: false,
      loading: true,
      isAboutRoute: false,
      headerData: {
        area: "Harrisburg-Carlisle, PA Metro Area",
        bznaics: "238220.000000",
        client_logo: "",
        client_name: "",
        developer_logo: null,
        developer_name: null,
        error: false,
        errorCode: "none",
        industry: "Plumbing, Heating, and Air-Conditioning Contractors",
        isReport: true,
        sales_class: "$1m - $2.49m",
        sector: "Construction",
        title: "Valuation Report"
      },
    };
  },
  methods: {
    ...mapActions({
      getVestimateReport: 'user/getVestimateReport',
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
    }),
    async init() {
      this.loading = true;

      await this.$store.dispatch('sample/getValuationReport').then(async (res) => {
        await this.$store.commit('user/SET_VESTIMATE_REPORT', res);
        this.getHeaderData();
        this.loading = false;
      });
    },
    checkRoute() {
      if (this.$route.name === 'SampleVRAbouttheData')
        return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/productHeader', {
          params: {
            product_id: this.vestimateReport.data.reportID,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.headerData = res.data;

        });
    },
  },
  mounted() {
    // reinitScrollbar();
    // initSidebar();
    this.isAboutRoute = this.checkRoute();
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      vestimateReport: state => state.user.vestimate_report,
    }),
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
    // sidebarMini() {
    //   this.minimizeSidebar();
    // },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.sidbar {
  .sidbar-box {
    .md-list-item-container:hover {
      background-color: #3e4345 !important;
    }

    .md-list-item-content {
      justify-content: center;
      flex-direction: column-reverse;
      &:hover,
      &:active {
        background-color: #3e4345 !important;
        .md-icon {
          color: #3b7ef1 !important;
          svg {
            fill: #3b7ef1 !important;
          }
        }
      }

      .md-icon {
        color: white !important;
        margin: 0 !important;
        svg {
          fill: white !important;
          &:hover,
          &:active {
            fill: #3b7ef1 !important;
          }
        }
      }
      p {
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}
.pulse {
  height: 120px !important;
  top: 1.7rem !important;
  background: transparent !important;
}
</style>
